import { render, staticRenderFns } from "./tonguereport.vue?vue&type=template&id=e8ca62ee&scoped=true&"
import script from "./tonguereport.vue?vue&type=script&lang=js&"
export * from "./tonguereport.vue?vue&type=script&lang=js&"
import style0 from "./tonguereport.vue?vue&type=style&index=0&id=e8ca62ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ca62ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8ca62ee')) {
      api.createRecord('e8ca62ee', component.options)
    } else {
      api.reload('e8ca62ee', component.options)
    }
    module.hot.accept("./tonguereport.vue?vue&type=template&id=e8ca62ee&scoped=true&", function () {
      api.rerender('e8ca62ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/tonguereport.vue"
export default component.exports